import React from 'react';
import { Container } from '../components/Container';
import { Store, DollarSign, Users, Clock, CheckCircle2, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TeamStores() {
  return <div className="w-full bg-white" data-id="element-733">
      {/* Hero */}
      <div className="bg-[#111827] text-white py-12 lg:py-16" data-id="element-734">
        <Container data-id="element-735">
          <div className="flex flex-col lg:flex-row items-center gap-10" data-id="element-736">
            <div className="lg:w-1/2" data-id="element-737">
              <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-3 leading-tight" data-id="element-738">
                Custom Team Stores
              </h1>
              <div className="w-16 h-1.5 bg-pts-red mb-5" data-id="element-739"></div>
              <p className="text-lg text-gray-300 mb-6 leading-relaxed" data-id="element-740">
                A team store is a dedicated webpage where your approved fan
                items and team gear are grouped together. Players, parents,
                fans, and families can shop online year round or during a set
                ordering window.
              </p>
              <Link to="/contact" className="inline-block bg-pts-red hover:bg-pts-red-dark text-white px-7 py-3 rounded font-bold uppercase tracking-wide transition-colors" data-id="element-741">
                Start a Team Store
              </Link>
            </div>
            <div className="lg:w-1/2 w-full" data-id="element-742">
              <img src="https://cdn.magicpatterns.com/uploads/4Ruc1nsuJQkNnM2DaogboL/team-apparel-stores.jpg" alt="Custom team apparel product collection" className="rounded-xl shadow-2xl border border-gray-800 w-full h-auto" data-id="element-743" />
            </div>
          </div>
        </Container>
      </div>

      {/* How It Works */}
      <section className="py-20 bg-gray-50" data-id="element-744">
        <Container data-id="element-745">
          <div className="text-center mb-16" data-id="element-746">
            <h2 className="font-oswald text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-747">
              How Team Stores Work
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mx-auto" data-id="element-748"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-749">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-750">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-751">
                1
              </div>
              <Store className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-752" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-753">
                We Build the Store
              </h3>
              <p className="text-gray-600" data-id="element-754">
                You pick the gear and provide your logos. We build a dedicated
                webpage for your team's approved fan items.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-755">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-756">
                2
              </div>
              <Users className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-757" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-758">
                Parents & Fans Order
              </h3>
              <p className="text-gray-600" data-id="element-759">
                Share the link with your organization. Everyone orders and pays
                individually year round or during a set time window.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-760">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-761">
                3
              </div>
              <Clock className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-762" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-763">
                We Produce & Ship
              </h3>
              <p className="text-gray-600" data-id="element-764">
                The store closes, we produce all the orders together, and ship
                them out. No inventory or money collection for you.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Fundraising */}
      <section className="py-20 bg-white border-y border-gray-200" data-id="element-765">
        <Container data-id="element-766">
          <div className="flex flex-col md:flex-row items-center gap-12 max-w-5xl mx-auto" data-id="element-767">
            <div className="md:w-1/3 flex justify-center" data-id="element-768">
              <div className="w-48 h-48 bg-red-50 rounded-full flex items-center justify-center border-8 border-white shadow-xl" data-id="element-769">
                <DollarSign className="h-24 w-24 text-pts-red" data-id="element-770" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-771">
              <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-772">
                Built-In Fundraising
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-773">
                Team stores are one of the easiest ways to raise money for your
                program. We provide you with our base factory-direct pricing,
                and you decide how much of a rebate to add to each item.
              </p>
              <ul className="space-y-3" data-id="element-774">
                <li className="flex items-center text-gray-700" data-id="element-775">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-776" /> You
                  control the retail price
                </li>
                <li className="flex items-center text-gray-700" data-id="element-777">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-778" /> We send
                  you a check for the profits after the store closes
                </li>
                <li className="flex items-center text-gray-700" data-id="element-779">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-780" /> No
                  upfront costs or leftover inventory
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </section>

      {/* Get Your Team Store Started */}
      <section className="py-20 bg-gray-50" data-id="element-781">
        <Container data-id="element-782">
          <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden" data-id="element-783">
            <div className="grid grid-cols-1 lg:grid-cols-5" data-id="element-784">
              {/* Left: Pitch */}
              <div className="lg:col-span-2 bg-[#111827] text-white p-10 lg:p-12 flex flex-col" data-id="element-785">
                <div className="inline-block self-start bg-pts-red text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded mb-6" data-id="element-786">
                  Let's Get Your Gear Online
                </div>
                <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase mb-4 leading-tight" data-id="element-787">
                  Get Your Club, Team, or School Gear Online
                </h2>
                <div className="w-16 h-1 bg-pts-red mb-6" data-id="element-788"></div>
                <p className="text-gray-300 mb-8 leading-relaxed" data-id="element-789">
                  Tell us about your organization and we'll set up a
                  team-specific online store where your players, parents, and
                  fans can easily purchase your gear. No setup fees, no
                  inventory, no headaches.
                </p>

                <ul className="space-y-3 mb-10 text-sm text-gray-300" data-id="element-790">
                  <li className="flex items-center" data-id="element-791">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-792" />
                    Built and hosted by PTS
                  </li>
                  <li className="flex items-center" data-id="element-793">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-794" />
                    Optional fundraising rebate
                  </li>
                  <li className="flex items-center" data-id="element-795">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-796" />
                    We produce and ship every order
                  </li>
                </ul>

                <div className="mt-auto space-y-3 pt-6 border-t border-gray-700" data-id="element-797">
                  <a href="tel:8882188647" className="flex items-center text-white hover:text-pts-red transition-colors" data-id="element-798">
                    <Phone className="h-5 w-5 text-pts-red mr-3" data-id="element-799" />
                    <span className="font-bold" data-id="element-800">888.218.8647</span>
                  </a>
                  <a href="mailto:savemoney@getcustomuniforms.com" className="flex items-center text-gray-300 hover:text-white transition-colors text-sm" data-id="element-801">
                    <Mail className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-802" />
                    <span className="break-all" data-id="element-803">
                      savemoney@getcustomuniforms.com
                    </span>
                  </a>
                </div>
              </div>

              {/* Right: Form */}
              <div className="lg:col-span-3 p-10 lg:p-12" data-id="element-804">
                <h3 className="font-oswald text-2xl font-bold uppercase text-gray-900 mb-2" data-id="element-805">
                  Request Your Team Store
                </h3>
                <p className="text-gray-600 mb-8 text-sm" data-id="element-806">
                  Fill this out and a PTS team member will follow up within one
                  business day.
                </p>

                <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-807">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-808">
                    <div data-id="element-809">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-810">
                        Your Name *
                      </label>
                      <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-811" />
                    </div>
                    <div data-id="element-812">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-813">
                        Your Role
                      </label>
                      <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-814">
                        <option data-id="element-815">Select role</option>
                        <option data-id="element-816">Coach</option>
                        <option data-id="element-817">Team Manager</option>
                        <option data-id="element-818">Athletic Director</option>
                        <option data-id="element-819">Parent</option>
                        <option data-id="element-820">Club / League Director</option>
                        <option data-id="element-821">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-822">
                    <div data-id="element-823">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-824">
                        Email *
                      </label>
                      <input type="email" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-825" />
                    </div>
                    <div data-id="element-826">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-827">
                        Phone
                      </label>
                      <input type="tel" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-828" />
                    </div>
                  </div>

                  <div data-id="element-829">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-830">
                      Organization / Team / School Name *
                    </label>
                    <input type="text" required placeholder="e.g. Boca Raton Wildcats Baseball" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-831" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-832">
                    <div data-id="element-833">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-834">
                        Sport / Type
                      </label>
                      <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-835">
                        <option data-id="element-836">Select sport</option>
                        <option data-id="element-837">Baseball</option>
                        <option data-id="element-838">Basketball</option>
                        <option data-id="element-839">Football</option>
                        <option data-id="element-840">Softball</option>
                        <option data-id="element-841">Soccer</option>
                        <option data-id="element-842">Cheer</option>
                        <option data-id="element-843">Volleyball</option>
                        <option data-id="element-844">Track & Field</option>
                        <option data-id="element-845">Groupwear / Other</option>
                      </select>
                    </div>
                    <div data-id="element-846">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-847">
                        Approx. # of Members
                      </label>
                      <input type="text" placeholder="e.g. 25 players + parents" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-848" />
                    </div>
                  </div>

                  <div data-id="element-849">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-850">
                      Tell us about your team store
                    </label>
                    <textarea rows={4} placeholder="What gear are you thinking about? Are you using this for fundraising? When would you like the store to open?" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none resize-none" data-id="element-851"></textarea>
                  </div>

                  <div className="pt-2" data-id="element-852">
                    <button type="submit" className="w-full bg-pts-red hover:bg-pts-red-dark text-white px-6 py-3.5 rounded font-bold uppercase tracking-wide transition-colors text-base" data-id="element-853">
                      Request My Team Store
                    </button>
                    <p className="text-xs text-gray-500 text-center mt-3" data-id="element-854">
                      Prefer to talk first? Call{' '}
                      <a href="tel:8882188647" className="text-pts-red font-bold hover:underline" data-id="element-855">
                        888.218.8647
                      </a>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>;
}